import React from 'react';
import { DownloadIcon, FileTextIcon, MailIcon, ShieldCheckIcon, ArrowLeftIcon, ExternalLinkIcon, ImageIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function InvestorDeckPage() {
  return <div className="min-h-screen bg-gray-50 font-sans text-[#111111]" data-id="element-1625">
      {/* Private Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-1626">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-1627">
          <div className="flex items-center space-x-4" data-id="element-1628">
            <Link to="/" className="text-gray-500 hover:text-[#631bb7] transition-colors" data-id="element-1629">
              <ArrowLeftIcon size={20} data-id="element-1630" />
            </Link>
            <div className="h-6 w-px bg-gray-200" data-id="element-1631"></div>
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-6" data-id="element-1632" />
            <span className="bg-gray-100 text-gray-600 text-xs font-semibold px-2 py-1 rounded-full uppercase tracking-wide" data-id="element-1633">
              Investor Portal
            </span>
          </div>
          <div className="text-sm text-gray-500" data-id="element-1634">
            Confidential & Proprietary
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12 space-y-16" data-id="element-1635">
        {/* Welcome / Hero */}
        <section className="text-center max-w-3xl mx-auto" data-id="element-1636">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-[#111111]" data-id="element-1637">
            Building the Digital Fiduciary for Families
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1638">
            Welcome to the Caveo investor portal. Here you'll find our latest
            materials, brand assets, and strategic overview as we redefine
            family digital safety.
          </p>
        </section>

        {/* The Deck Section */}
        <section className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1639">
          <div className="p-8 border-b border-gray-100 flex justify-between items-center" data-id="element-1640">
            <div data-id="element-1641">
              <h2 className="text-2xl font-bold flex items-center" data-id="element-1642">
                <FileTextIcon className="mr-3 text-[#8041bf]" data-id="element-1643" />
                Investor Deck
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-1644">Q1 2026 Strategic Overview</p>
            </div>
            <button className="bg-[#8041bf] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#6a35a0] transition-colors flex items-center shadow-sm" data-id="element-1645">
              <DownloadIcon size={18} className="mr-2" data-id="element-1646" />
              Download PDF
            </button>
          </div>

          {/* Deck Placeholder / Preview Area */}
          <div className="bg-gray-50 aspect-video flex flex-col items-center justify-center text-gray-400 border-b border-gray-100" data-id="element-1647">
            <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center mb-4" data-id="element-1648">
              <FileTextIcon size={40} className="text-gray-400" data-id="element-1649" />
            </div>
            <p className="font-medium" data-id="element-1650">Deck Preview Unavailable</p>
            <p className="text-sm mt-2" data-id="element-1651">
              Please download the PDF to view the full presentation.
            </p>
          </div>

          <div className="p-6 bg-gray-50 flex justify-between items-center text-sm text-gray-500" data-id="element-1652">
            <span data-id="element-1653">Last updated: February 2026</span>
            <span data-id="element-1654">File size: 4.2 MB</span>
          </div>
        </section>

        {/* About Caveo */}
        <section className="grid md:grid-cols-2 gap-12 items-center" data-id="element-1655">
          <div data-id="element-1656">
            <h2 className="text-3xl font-bold mb-6" data-id="element-1657">Why Caveo?</h2>
            <div className="space-y-6" data-id="element-1658">
              <div className="flex" data-id="element-1659">
                <div className="flex-shrink-0 mt-1" data-id="element-1660">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-1661">
                    <ShieldCheckIcon size={16} className="text-[#631bb7]" data-id="element-1662" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-1663">
                  <h3 className="text-lg font-bold text-[#111111]" data-id="element-1664">
                    The Digital Fiduciary
                  </h3>
                  <p className="text-gray-600 mt-1" data-id="element-1665">
                    We're pioneering a new category of trust. Unlike affiliate
                    sites, our only customer is the family. We provide unbiased,
                    expert guidance without the conflict of interest.
                  </p>
                </div>
              </div>

              <div className="flex" data-id="element-1666">
                <div className="flex-shrink-0 mt-1" data-id="element-1667">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-1668">
                    <ExternalLinkIcon size={16} className="text-[#631bb7]" data-id="element-1669" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-1670">
                  <h3 className="text-lg font-bold text-[#111111]" data-id="element-1671">
                    Massive Market Gap
                  </h3>
                  <p className="text-gray-600 mt-1" data-id="element-1672">
                    Security tools protect devices. We protect people. The
                    "Family Chief Security Officer" needs a platform, not just
                    another antivirus subscription.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#1a0647] text-white p-8 rounded-2xl shadow-lg relative overflow-hidden" data-id="element-1673">
            <div className="relative z-10" data-id="element-1674">
              <h3 className="text-2xl font-bold mb-4" data-id="element-1675">Our Vision</h3>
              <p className="text-lg leading-relaxed text-gray-200 mb-6" data-id="element-1676">
                "To build the world's most trusted family safety platform, where
                technology bridges generations instead of dividing them."
              </p>
              <div className="flex items-center space-x-4 pt-4 border-t border-white/20" data-id="element-1677">
                <div data-id="element-1678">
                  <div className="text-3xl font-bold" data-id="element-1679">45M+</div>
                  <div className="text-sm text-gray-400" data-id="element-1680">
                    Target US Households
                  </div>
                </div>
                <div className="h-10 w-px bg-white/20" data-id="element-1681"></div>
                <div data-id="element-1682">
                  <div className="text-3xl font-bold" data-id="element-1683">$12B</div>
                  <div className="text-sm text-gray-400" data-id="element-1684">
                    Market Opportunity
                  </div>
                </div>
              </div>
            </div>
            {/* Abstract background decoration */}
            <div className="absolute top-0 right-0 -mt-10 -mr-10 w-64 h-64 bg-[#631bb7] rounded-full opacity-20 blur-3xl" data-id="element-1685"></div>
            <div className="absolute bottom-0 left-0 -mb-10 -ml-10 w-64 h-64 bg-[#00f4f8] rounded-full opacity-10 blur-3xl" data-id="element-1686"></div>
          </div>
        </section>

        {/* Brand Collateral */}
        <section data-id="element-1687">
          <div className="flex items-center mb-8" data-id="element-1688">
            <h2 className="text-2xl font-bold" data-id="element-1689">Brand Assets</h2>
            <div className="h-px bg-gray-200 flex-grow ml-6" data-id="element-1690"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1691">
            {/* Logo Pack */}
            <div className="bg-white p-6 rounded-xl border border-gray-200 hover:shadow-md transition-shadow" data-id="element-1692">
              <div className="h-32 bg-gray-50 rounded-lg flex items-center justify-center mb-4" data-id="element-1693">
                <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo Logo" className="h-8" data-id="element-1694" />
              </div>
              <h3 className="font-bold text-lg mb-1" data-id="element-1695">Logo Pack</h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-1696">
                Vector (SVG) and PNG formats in full color, white, and black.
              </p>
              <button className="text-[#8041bf] font-semibold text-sm flex items-center hover:underline" data-id="element-1697">
                <DownloadIcon size={16} className="mr-2" data-id="element-1698" />
                Download ZIP (12MB)
              </button>
            </div>

            {/* Brand Guidelines */}
            <div className="bg-white p-6 rounded-xl border border-gray-200 hover:shadow-md transition-shadow" data-id="element-1699">
              <div className="h-32 bg-gray-50 rounded-lg flex items-center justify-center mb-4" data-id="element-1700">
                <div className="text-center" data-id="element-1701">
                  <div className="w-12 h-12 bg-white rounded-full shadow-sm flex items-center justify-center mx-auto mb-2" data-id="element-1702">
                    <span className="text-2xl font-bold text-[#8041bf]" data-id="element-1703">
                      Aa
                    </span>
                  </div>
                </div>
              </div>
              <h3 className="font-bold text-lg mb-1" data-id="element-1704">Brand Guidelines</h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-1705">
                Typography, color palette, and usage rules for the Caveo brand.
              </p>
              <button className="text-[#8041bf] font-semibold text-sm flex items-center hover:underline" data-id="element-1706">
                <DownloadIcon size={16} className="mr-2" data-id="element-1707" />
                Download PDF (4MB)
              </button>
            </div>

            {/* Product Screenshots */}
            <div className="bg-white p-6 rounded-xl border border-gray-200 hover:shadow-md transition-shadow" data-id="element-1708">
              <div className="h-32 bg-gray-50 rounded-lg flex items-center justify-center mb-4" data-id="element-1709">
                <ImageIcon className="text-gray-400" size={32} data-id="element-1710" />
              </div>
              <h3 className="font-bold text-lg mb-1" data-id="element-1711">Product Shots</h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-1712">
                High-res screenshots of the mobile and web application
                interface.
              </p>
              <button className="text-[#8041bf] font-semibold text-sm flex items-center hover:underline" data-id="element-1713">
                <DownloadIcon size={16} className="mr-2" data-id="element-1714" />
                Download ZIP (28MB)
              </button>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="bg-white rounded-2xl p-8 md:p-12 border border-gray-200 text-center" data-id="element-1715">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1716">
            Questions or Due Diligence Requests?
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-1717">
            We're happy to provide additional data room access or schedule a
            deep dive into our product roadmap and go-to-market strategy.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1718">
            <a href="mailto:founders@caveo.co" className="inline-flex items-center justify-center bg-[#111111] text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors" data-id="element-1719">
              <MailIcon size={18} className="mr-2" data-id="element-1720" />
              Email the Founders
            </a>
            <a href="#" className="inline-flex items-center justify-center bg-white border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors" data-id="element-1721">
              Schedule a Call
            </a>
          </div>
        </section>
      </main>

      <footer className="bg-white border-t border-gray-200 py-8 mt-12" data-id="element-1722">
        <div className="max-w-7xl mx-auto px-6 text-center text-sm text-gray-500" data-id="element-1723">
          <p data-id="element-1724">&copy; 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.</p>
          <p className="mt-2 text-xs text-gray-400" data-id="element-1725">
            This page contains confidential information intended only for
            authorized investors. Do not share or distribute without permission.
          </p>
        </div>
      </footer>
    </div>;
}